export default __webpack_public_path__ + "static/media/missing_cover.67cea59f.png";